const findPathRoute = (routes, path) => {
    return routes.find((item) => item.path === path);
};

const addRoute = (routes, allRoutes, path) => {
    const route = findPathRoute(allRoutes, path);
    if (route) routes.push(route);
};

const getProtectedRoutes = (authProtectedRoutes, permissions, high_division, is_patronager, is_observer, is_diaspora_coordinator, is_ftv_coordinator) => {
    let protectedRoutes = [];

    // Always available
    addRoute(protectedRoutes, authProtectedRoutes, "/dashboard");
    addRoute(protectedRoutes, authProtectedRoutes, "/profile");
    addRoute(protectedRoutes, authProtectedRoutes, "/settings");
    addRoute(protectedRoutes, authProtectedRoutes, "/configurations");

    // Tasks (new routes - specific paths first!)
    addRoute(protectedRoutes, authProtectedRoutes, "/tasks/qr");
    addRoute(protectedRoutes, authProtectedRoutes, "/tasks/:id");
    addRoute(protectedRoutes, authProtectedRoutes, "/tasks");

    // Backwards compatibility redirects
    addRoute(protectedRoutes, authProtectedRoutes, "/tasks-received");
    addRoute(protectedRoutes, authProtectedRoutes, "/task-qr-list");

    // Election modules
    addRoute(protectedRoutes, authProtectedRoutes, "/observer-module");
    addRoute(protectedRoutes, authProtectedRoutes, "/patronager-module");

    // Patronage
    addRoute(protectedRoutes, authProtectedRoutes, "/patronage-referred");
    addRoute(protectedRoutes, authProtectedRoutes, "/emigrant");

    if (is_diaspora_coordinator) {
        addRoute(protectedRoutes, authProtectedRoutes, "/diaspora-references");
    }

    if (is_ftv_coordinator) {
        addRoute(protectedRoutes, authProtectedRoutes, "/my-vhp-voters");
    }

    if (is_patronager) {
        addRoute(protectedRoutes, authProtectedRoutes, "/my-patronage");
    }

    // News & Notifications
    addRoute(protectedRoutes, authProtectedRoutes, "/news-grid");
    addRoute(protectedRoutes, authProtectedRoutes, "/notifications");

    // Utility
    addRoute(protectedRoutes, authProtectedRoutes, "/pages-comingsoon");
    addRoute(protectedRoutes, authProtectedRoutes, "/");

    return protectedRoutes;
};

export default getProtectedRoutes;
